let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("deQ2I")).then(() => parcelRequire('v5uKD'));